module.exports = __webpack_public_path__ + "static/img/box-open.f6d5c6cf.png";